import './Icon.css';
import { IconProps } from './iconType';

export const PlusIcon: React.FC<IconProps> = ({
  size = 9,
  color,
  className,
}) => {
  return (
    <span
      className={['icon', className].filter(Boolean).join(' ')}
      style={{ width: size, height: size, color }}
    >
      <svg
        width={size}
        height={size}
        viewBox={`0 0 ${size} ${size}`}
        fill='none'
      >
        <path d='M4 4V0H5V4H9V5H5V9H4V5H0V4H4Z' fill='currentColor' />
      </svg>
    </span>
  );
};
